{
  "processPage": {
    "assignmentTitle": "Review Process Step Assignment",
    "assignmentDescription": "Check the assignment details. If everything fits, accept and start recording your process step. If you're not the right person, assign the step to someone else.",
    "YourProcessStep": "Your Process Step",
    "ProcessStart": "Process Start",
    "Output": "Output",
    "Successor": "Successor",
    "Assignee": "Assignee",
    "chooseAllSuccessor": "Choose all successors who will receive your output.",
    "chooseAllSuccessorDecision": "Choose all successors who will continue the process with this option.",
    "chooseASuccessor": "Choose a successor who will receive your output.",
    "chooseAllAssignee": "Choose all people who can start the process.",
    "chooseAnAssignee": "Choose who will start the process.",
    "aSuccessorCanBe": "A successor can be a person, a function, a system or an external contact.",
    "anAssigneeCanBe": "An assignee can be a person, a function or a system.",
    "addSuccessor": "Add a Successor",
    "addAssignee": "Add Assignee",
    "whoElseDoesThis": "Who else does this?",
    "selectColleaguesWhoAlsoPerform": "Select people who could take over this step independently of you – e.g. as a stand-in. Multiple possible.",
    "statusPending": "Pending",
    "Person": "Person",
    "thisPersonWillReceive": "This person will receive an invitation to describe the next process step.",
    "thisPersonWillReceiveStart": "This person will be invited to describe the first process step.",
    "teamWillReceive": "This function will receive an invitation to describe the next process step.",
    "teamWillReceiveStart": "This function will be invited to describe the first process step.",
    "Unclear": "Unclear",
    "processWillEnd": "The process sequence will end here",
    "processWillReturnToOwner": "The process will be returned to the process owner",
    "None": "No successor",
    "systemOwnerWillReceive": "The system owner will be invited to describe the next process step.",
    "systemOwnerWillReceiveStart": "The system owner will be invited to describe the first process step.",
    "externalContactOwnerWillReceive": "The process owner will be invited to describe the step on behalf of the external contact.",
    "selectPersonPlaceholder": "Choose a person...",
    "selectSystemPlaceholder": "Choose a software system...",
    "selectExternalContactPlaceholder": "Choose an external contact...",
    "Processname": "Process name",
    "processFlow": "Process Flow",
    "processFlowDescription": "View the complete process flow diagram showing all recorded steps",
    "showInProcess": "Show in process",
    "viewProcessDetails": "View Process Details",
    "assignSomeoneElse": "Assign someone else",
    "Saved": "Saved",
    "unsavedChanges": "Unsaved changes",
    "processNameDesc": "Process details",
    "multiple-times-daily": "Multiple Times Daily",
    "once-a-day": "Once a Day",
    "several-times-a-week": "Several times a week",
    "once-per-week": "Once per Week",
    "every-two-weeks": "Every two weeks",
    "every-three-weeks": "Every three weeks",
    "monthly": "Monthly",
    "quarterly": "Quarterly",
    "semi-annually": "Semi-Annually",
    "yearly": "Yearly",
    "LastChange": "Last Change",
    "ProcessStepMembers": "Process Step Members",
    "ProcessStep": "Process Step",
    "Check": "Check",
    "ratingRequired": "Rating is required",
    "Saving": "Saving...",
    "surveyRequired": "Please provide an answer",
    "total": "Total: {{total}}",
    "showSelected": "Show selected ({{amount}})",
    "Reassign": "Reassign",
    "AllDepartments": "All Departments"
  },
  "processFlow": {
    "bpmnPreview": "Process Preview",
    "openFullscreen": "Open Fullscreen",
    "fullscreenTitle": "Process Flow Visualization",
    "viewMode": {
      "label": "View",
      "standard": "Standard",
      "rating": "By rating",
      "capacity": "By capacity binding",
      "combined": "Combined score"
    },
    "heatmapLegend": {
      "noData": "No data",
      "rating": {
        "good": "Avg ≥ {{min}} stars",
        "medium": "Avg {{min}} – {{max}} stars",
        "critical": "Avg < {{min}} stars"
      },
      "capacity": {
        "good": "< {{max}}% of maximum",
        "medium": "{{min}} – {{max}}% of maximum",
        "critical": "≥ {{min}}% of maximum"
      },
      "combined": {
        "good": "Score ≥ {{min}}%",
        "medium": "Score {{min}} – {{max}}%",
        "critical": "Score < {{max}}%"
      },
      "hoursUnit": "h",
      "combinedInfo": "The combined score rates each step from 0–100% by mixing two things: how good its rating is (60%) and how light its capacity load is (40%) — a step that ties up fewer hours scores higher. Green means good on both counts; red means a poor rating, a heavy capacity load, or both."
    },
    "stepDetails": "Step {{number}} Details",
    "stepPrefix": "Step {{number}}",
    "decision": "Decision",
    "assignedTo": "Assigned To",
    "recordedBy": "Recorded By",
    "taskDescription": "Task Description",
    "inputs": "Inputs",
    "inputsHint": "Add everything that comes in and that you need to carry out the process step: an event that triggers the step (e.g. quarterly meeting) or information you process (e.g. a report or metric). Pure reference material like guidelines belongs under “Documents” instead.",
    "helpers": "Helpers",
    "helpersHint": "What and who do you use to get this step done? Systems you use, people and functions that must be involved, and documents you need.",
    "persons": "Person(s)",
    "teams": "Function(s)",
    "systems": "System(s)",
    "documents": "Document(s)",
    "successors": "Successors",
    "noSuccessors": "Process ends here",
    "unclearSuccessors": "Unclear continuation",
    "pendingSystem": "Pending system",
    "pendingOrgFunction": "Pending function",
    "decisionRules": "Decision Rules",
    "whoElseDoesThis": "Who Else Does This",
    "whoElseDoesThisDescription": "Select people who could take over this step independently of you – e.g. as a stand-in. Multiple possible.",
    "whoElseDoesThisDescriptionEditor": "People who also carry out this step – e.g. as a stand-in. Multiple possible.",
    "status": {
      "pending": "Pending",
      "accepted": "Accepted",
      "declined": "Declined"
    },
    "feedback": "Feedback",
    "variantCheck": {
      "title": "Variant Check",
      "same": "same way",
      "different": "differently",
      "notPerformed": "not performed",
      "viewVariants": "View variants"
    },
    "createdAt": "Created",
    "updatedAt": "Updated",
    "completedAt": "Completed",
    "noStepsRecorded": "No process steps recorded yet",
    "startRecordingHint": "Start recording to see the process flow",
    "output": "Output",
    "expandTable": "Expand Table",
    "endLabel": "End",
    "noFurtherSteps": "No further steps",
    "unclearContinuation": "Unclear continuation",
    "swimlane": {
      "unassigned": "Unassigned"
    },
    "viralPlaceholder": {
      "pending": "Awaiting recording",
      "accepted": "Recording in progress",
      "pendingUnclear": "Unclear — awaiting process owner resolution",
      "proposed": "Proposed — awaiting approval",
      "declined": "Proposed — declined"
    },
    "editable": {
      "noAssignee": "No assignee",
      "addInput": "Add input",
      "reorderInput": "Drag to reorder input",
      "removeInput": "Remove input",
      "addHelper": "Add helper",
      "addArtifact": "Add new artifact",
      "noSuccessors": "No successors set",
      "addSuccessor": "Add successor",
      "removeSuccessor": "Remove successor",
      "noDecisionRules": "No decision rules defined",
      "editDecisionRules": "Edit decision rules",
      "noHelpers": "No helpers selected",
      "editHelpers": "Edit helpers",
      "editHelpersDescription": "Select persons, functions, and systems that help with this step.",
      "none": "None",
      "personsCount": "{{count}} persons",
      "personsCount_one": "{{count}} person",
      "personsCount_other": "{{count}} persons",
      "teamsCount": "{{count}} functions",
      "teamsCount_one": "{{count}} function",
      "teamsCount_other": "{{count}} functions",
      "systemsCount": "{{count}} systems",
      "systemsCount_one": "{{count}} system",
      "systemsCount_other": "{{count}} systems",
      "documentsCount": "{{count}} documents",
      "documentsCount_one": "{{count}} document",
      "documentsCount_other": "{{count}} documents"
    },
    "contextMenu": {
      "addStep": "Add new step",
      "addEvent": "Add event",
      "addEventForStep": "Add event for step",
      "editStep": "Edit step",
      "deleteStep": "Delete step",
      "editEvent": "Edit event",
      "deleteEvent": "Delete event",
      "markAsEnd": "Mark as end",
      "markUnclear": "Mark as unclear",
      "convertToAssignment": "Convert to assignment",
      "convertToStep": "Convert to step",
      "mergeNode": "Merge into…",
      "mergeDisabledHasSuccessor": "Only steps without a successor can be merged",
      "insertBetween": "Insert step between",
      "forkFromSource": "Open parallel branch",
      "mergeIntoTarget": "Merge parallel branch",
      "deleteEdge": "Delete",
      "saveAsStepTemplate_one": "Save as step template ({{count}} element)",
      "saveAsStepTemplate_other": "Save as step template ({{count}} elements)",
      "insertStepTemplate": "Insert from step template"
    },
    "mergeDialog": {
      "title": "Merge steps",
      "description": "Pick another step to merge this one with, then choose which step remains.",
      "selectCandidate": "Step to merge with",
      "searchCandidates": "Search steps…",
      "noCandidates": "No other steps to merge with",
      "unnamedNode": "Unnamed step",
      "assignedTo": "Assigned to: {{name}}",
      "survivorLabel": "Which step should remain?",
      "keepSource": "Keep \"{{name}}\"",
      "keepTarget": "Keep \"{{name}}\"",
      "resultKindStep": "The result will be a step.",
      "resultKindAssignment": "The result will be an assignment.",
      "confirm": "Merge",
      "cancel": "Cancel"
    },
    "detailPanel": {
      "dragToMove": "Drag to move (double-click to reset)",
      "dragToResize": "Drag to resize"
    }
  },
  "processDetail": {
    "editProcess": "Edit Process",
    "export": {
      "title": "Export process",
      "button": "Export",
      "description": "Choose which sections to include in the downloaded JSON file.",
      "steps": "Steps",
      "assignments": "Assignments",
      "capacity": "Capacity (sensitive)",
      "context": "Organization context (roles, departments, systems, teams, organigram)",
      "format": "Format",
      "formatJson": "JSON",
      "formatYaml": "YAML",
      "formatExcel": "Excel",
      "includeMetrics": "Include metrics (Rating, Frequency, Duration, Capacity Binding)",
      "download": "Download",
      "cancel": "Cancel",
      "success": "Process exported",
      "error": "Failed to export process",
      "capacitySource": "Capacity source",
      "capacitySourceSurvey": "surveyed",
      "capacitySourceManual": "entered manually"
    }
  },
  "processFlowEditor": {
    "newTask": "New task",
    "newDecision": "New decision",
    "emptyNote": "Empty note",
    "noteLink": "Link to steps",
    "noteLinkHint": "Click steps to link or unlink · click empty space to finish",
    "noteCategory": {
      "context": "Context",
      "problem": "Problem",
      "question": "Question",
      "todo": "To-do"
    },
    "ruleNoOutput": "Rule has no outgoing connection or end state",
    "eventDisconnected": "Event has no outgoing connection",
    "sendInvitations": "Send invitations",
    "noInvitations": "No invitations to send",
    "sendAll": "Send all",
    "savePositions": "Save positions",
    "pendingInvitations": "Pending invitations ({{count}})",
    "swimlane": {
      "moveUp": "Move lane up",
      "moveDown": "Move lane down",
      "color": "Lane color",
      "resetColor": "Reset color",
      "customColorPlaceholder": "#RRGGBB",
      "applyColor": "Apply"
    }
  },
  "processDraft": {
    "preparing": "Preparing draft...",
    "loadError": "Could not load the draft.",
    "refetchErrorBanner": "Changes are currently not being saved — connection or session problem. Please reload the page.",
    "draftBadge": "Draft",
    "lastSaved": "Last saved {{when}}",
    "publish": "Publish",
    "discard": "Discard draft",
    "discardConfirm": "Discard changes?",
    "addStep": "Add Step",
    "addNote": "Add note",
    "stepDetail": "Step",
    "assigneeSet": "Assignee selected",
    "assigneeNone": "No assignee yet",
    "pickAssignee": "Pick assignee",
    "pickActionType": "Pick an action type to continue.",
    "needsInput": "Needs input",
    "decisionEditNotice": "Decision rules are edited on the live step after publishing.",
    "taskDescription": "Task description",
    "taskDescriptionPlaceholder": "What happens in this step?",
    "confirmDeleteStep": "Delete this step from the draft?",
    "confirmDisconnect": "Remove this connection?",
    "editor": {
      "generateWithAi": "Generate with AI",
      "generateWithAiDisabled": "Add inputs, a task description, or rules first",
      "generateWithAiError": "Failed to generate step summary",
      "descriptionPlaceholder": "Summarize this step…"
    },
    "mode": {
      "manual": "Manual",
      "viral": "Viral",
      "viralDisabledReason": "Only leaf steps with an upstream source can become viral assignments."
    },
    "surveys": {
      "heading": "Surveys",
      "reRequestToggleLabel": "Re-request survey on publish",
      "reRequestToggleHint": "When published, this step's performers are asked to fill in their survey again.",
      "publishReRequestAll": "Publish & re-request all surveys",
      "reRequestShort": "Re-request",
      "reRequestShortActive": "Re-request staged",
      "status": {
        "pending": "Pending",
        "completed": "Completed",
        "dismissed": "Does not perform",
        "toCreate": "Will be created",
        "invited": "Invited"
      },
      "variantStatus": {
        "pending": "Variant Check open",
        "answered": "Variant Check answered",
        "notApplicable": "No Variant Check"
      },
      "statusNone": "No surveys yet"
    },
    "unclearSuccessor": {
      "label": "Unclear successor"
    },
    "actionType": {
      "task": "Activity",
      "decision": "Decision"
    },
    "actionTypeHint": "Describe what happens in this step. If it's a normal task, choose “Activity”. If what follows depends on conditions (e.g. approved/rejected), choose “Decision”.",
    "card": {
      "unconfigured": "Unconfigured step",
      "taskLabel": "Task (no description)",
      "decisionLabel": "Decision (no rules)",
      "assigned": "Assigned",
      "pickAssignee": "Pick assignee",
      "needsInput": "Needs input",
      "willInvite": "Will invite"
    },
    "graphReason": {
      "no-inputs": "Step has no inputs",
      "no-outputs": "Step has no successor",
      "orphan": "Step is disconnected",
      "no-start-event": "The process has no start event — reopen the editor to restore it",
      "event-disconnected": "Event has no outgoing connection",
      "event-disconnected-named": "Event \"{{name}}\" has no outgoing connection",
      "rule-no-output": "Rule \"{{output}}\" has no outgoing connection or end state",
      "rule-no-output-unnamed": "A decision rule has no outgoing connection or end state",
      "unreachable": "Step is cut off from the rest of the process",
      "unreachable-named": "Event \"{{name}}\" is cut off from the rest of the process"
    },
    "publishErrors": {
      "title": "Publish blocked",
      "goToStep": "Go to step",
      "unnamedStep": "Unnamed step",
      "unnamedEvent": "Unnamed event",
      "processLevel": "Process",
      "fieldLabels": {
        "actionType": "Step type",
        "taskDescription": "Task description",
        "output": "Output text",
        "rules": "Rules",
        "assignedTo": "Assignee",
        "inputs": "Inputs",
        "helpers": "Helpers",
        "helperPersons": "Helper people",
        "helperOrgFunctions": "Helper functions",
        "helperSystems": "Helper systems",
        "helperDocuments": "Helper documents",
        "whoElseDoesThis": "Other participants",
        "generatedName": "Step name",
        "generatedDescription": "Step description",
        "manualCapacity": "Manual capacity"
      },
      "issueMessages": {
        "actionTypeRequired": "Step type is required",
        "taskDescriptionRequired": "Task description is required",
        "taskOutputRequired": "Output text is required",
        "rulesRequired": "At least one decision rule is required",
        "ruleOutputRequired": "Rule output is required",
        "ruleConditionRequired": "Rule needs at least one filled-in condition value",
        "stepAssigneeRequired": "Step needs an assignee",
        "assignmentAssigneeRequired": "Assignment needs an assignee",
        "assignmentInputRequired": "Assignment needs at least one input from an upstream step",
        "eventNameRequired": "Event name is required",
        "startEventDescriptionRequired": "Start event description is required"
      }
    },
    "draftConflict": {
      "title": "Editor edits and decentralized recording are in conflict",
      "body": "In the decentralized recording, process steps were captured that represent a different process flow than the latest unpublished state in the editor.",
      "yours": "Editor draft",
      "live": "Decentralized recording",
      "listEmpty": "(none)",
      "unnamedItem": "(unnamed)",
      "cancel": "Keep editor draft (the decentralized recording will be overwritten)",
      "discard": "Discard editor draft (the decentralized recording is correct)",
      "discardModalTitle": "Discard the editor draft?",
      "discardModalBody": "This permanently deletes your entire editor draft — every change across all steps, not just this one. The draft will be recreated from the current state of the decentralized recording. This cannot be undone.",
      "discardModalCancel": "Keep editor draft",
      "discardModalConfirm": "Discard editor draft",
      "publishAnyway": "Keep editor draft (the decentralized recording will be overwritten)",
      "publishAnywayModalTitle": "Overwrite the decentralized recording?",
      "publishAnywayModalBody": "You're about to overwrite the current state of the decentralized recording with your editor draft. In-flight decentralized recordings — open invitations — may be lost or invalidated. This can't be undone.",
      "publishAnywayModalCancel": "Back",
      "publishAnywayModalConfirm": "Overwrite",
      "unnamedStep": "Untitled step",
      "empty": "Step changed externally",
      "changesCount_one": "{{count}} change",
      "changesCount_other": "{{count}} changes"
    },
    "publishUnknownError": "Couldn't publish — please try again.",
    "invitesFailedToast_one": "The draft published, but {{count}} invitation couldn't be sent. Affected recipients will need to be re-invited.",
    "invitesFailedToast_other": "The draft published, but {{count}} invitations couldn't be sent. Affected recipients will need to be re-invited.",
    "issues": {
      "count_one": "{{count}} issue",
      "count_other": "{{count}} issues",
      "title": "Before publishing",
      "none": "No issues",
      "kinds": {
        "actionType": {
          "title": "Step type missing"
        },
        "taskDescription": {
          "title": "Task description missing"
        },
        "output": {
          "title": "Output missing"
        },
        "assignee": {
          "title": "No assignee"
        },
        "rules": {
          "title": "No decision rule"
        },
        "ruleOutput": {
          "title": "Rule {{number}}: output missing"
        },
        "ruleCondition": {
          "title": "Rule {{number}}: condition missing"
        },
        "assignmentInput": {
          "title": "No input",
          "hint": "Connect an upstream step to this placeholder."
        },
        "eventName": {
          "title": "Event name missing"
        },
        "eventDescription": {
          "title": "Description missing"
        },
        "noInputs": {
          "title": "No input",
          "hint": "Drag a connection from an upstream step to here."
        },
        "noOutputs": {
          "title": "No successor",
          "hint": "Connect a next step or mark this step as the end."
        },
        "decisionNoOutputs": {
          "title": "No rule has a target",
          "hint": "Connect every rule to a step or mark it as an end."
        },
        "orphan": {
          "title": "Not connected",
          "hint": "Connect the step to the flow – or delete it."
        },
        "ruleNoOutput": {
          "title": "Rule “{{output}}” has no target",
          "titleUnnamed": "A rule has no target",
          "hint": "Connect the rule to a step or mark it as an end."
        },
        "eventDisconnected": {
          "title": "Event not connected",
          "hint": "Connect the event to the step it triggers."
        },
        "unreachable": {
          "title": "Cut off from the flow",
          "hint": "Connect this part to the rest of the process."
        },
        "noStartEvent": {
          "title": "No start event",
          "hint": "Reopen the editor to restore it."
        }
      }
    },
    "startEvent": {
      "title": "Start event",
      "titleHint": "Every start event of a process leads to an activity that takes place in your company. Tell us who performs this activity whenever the start event occurs.",
      "eventTypeLabel": "Trigger",
      "eventTypeHint": "The trigger determines what starts the process.\n\nManual start = A person actively kicks off the process.\nIncoming request = An email, an application, or another system, etc. starts the process.\nTime / Deadline = The process starts on a date or recurringly (e.g. monthly).",
      "nameLabel": "Name",
      "descriptionLabel": "Description",
      "namePlaceholder": "What triggers this process?",
      "descriptionPlaceholder": "Describe what triggers this event (e.g. employee submits a vacation request)",
      "assigneeCardSubtitle": "Choose who or what works on next with the start event",
      "assigneeCardHelper": "You can assign the start event to one or more people, functions (roles or teams), or systems."
    },
    "event": {
      "title": "Event",
      "eventTypeLabel": "Event type",
      "nameLabel": "Name",
      "descriptionLabel": "Description",
      "namePlaceholder": "What does this event represent?",
      "descriptionPlaceholder": "Describe the event"
    },
    "capacity": {
      "title": "Capacity",
      "enter": "Enter manually",
      "shadowHint": "entered manually — the surveyed value takes precedence",
      "excludedBySettingHint": "entered manually — the “Capacity source” setting excludes manual values",
      "dialogTitle": "Enter capacity manually",
      "frequency": "Frequency",
      "timesPerPeriod": "Count",
      "duration": "Duration (minutes)",
      "preview": "≈ {{month}} h/month · {{year}} h/year per person — extrapolated across the team like a survey answer",
      "previewPerPerson": "≈ {{month}} h/month · {{year}} h/year per person",
      "previewTeamTotal": "× {{count}} team members ≈ {{month}} h/month · {{year}} h/year in total",
      "previewTotal": "≈ {{month}} h/month · {{year}} h/year in total",
      "attribution": "entered manually by {{name}} on {{date}}",
      "remove": "Remove",
      "primitives": "{{frequency}} · {{minutes}} min",
      "saveError": "The capacity could not be saved."
    }
  },
  "processes": {
    "title": "Processes",
    "description": "Overview of all processes in your organization",
    "search": "Search processes...",
    "createProcess": "Create Process",
    "editDetails": "Edit Details",
    "createProcessDescription": "Add a new process to your organization",
    "editProcessDescription": "Update the details of this process",
    "empty": "No processes found",
    "nameLabel": "Process name",
    "owner": "Owner",
    "ownerPlaceholder": "Select process owner",
    "accountableClearLabel": "Default (department manager)",
    "accountablePlaceholder": "No one selected",
    "department": "Department",
    "departmentPlaceholder": "Select department",
    "ownerAndDepartmentEditHint": "Contact your organization manager to change the department or process owner",
    "namePlaceholder": "Enter process name, e.g. Submit vacation request",
    "descriptionPlaceholder": "Enter process description, e.g. “Process describes the flow of a vacation request from submission to approval”",
    "category": "Process Category",
    "categoryPlaceholder": "Select category",
    "notFound": "Process not found",
    "detailDescription": "View and manage process details",
    "details": "Process Details",
    "totalSteps": "Total Steps",
    "stepCount": "Steps",
    "stepsCount_one": "{{count}} step",
    "stepsCount_other": "{{count}} steps",
    "draftEdited": "Edited {{when}}",
    "draftEditedBy": "Edited {{when}} by {{name}}",
    "recordedHeader": "Recorded",
    "recordedTooltip": "recorded steps / total known steps",
    "averageRating": "Rating",
    "rating": "Rating",
    "Accountable": "Accountable",
    "ProcessOwner": "Process Owner",
    "involvedEntities": "Involved Entities",
    "involvedPeople": "People",
    "involvedTeams": "Teams",
    "involvedFunctions": "Functions",
    "usedSystems": "Systems",
    "usedArtifacts": "Documents",
    "externalContacts": "External Contacts",
    "usageAssigned": "Assigned to",
    "usageRecorded": "Recorded by",
    "usageWhoElseDoesThis": "Who else does this",
    "usageHelper": "Helper in",
    "noInvolvedPeople": "No people involved",
    "noUsedSystems": "No systems used",
    "noUsedArtifacts": "No documents used",
    "noExternalContacts": "No external contacts involved",
    "processSteps": "Process Steps",
    "processStep": "Process Step",
    "stepNumber": "Step #",
    "successorNumber": "Successor #",
    "successor": "Successor",
    "branches": "Branches",
    "stepsSheet": "Steps",
    "frequencyLabel": "Frequency",
    "duration": "Duration",
    "inputs": "Inputs",
    "output": "Output",
    "processStepMembers": "Process Step Members",
    "helperSystems": "Helpers (Systems)",
    "helperPersons": "Helpers (People)",
    "helperOrgFunctions": "Helpers (Functions)",
    "helperDocuments": "Helpers (Documents)",
    "lastChange": "Last Change",
    "variants": "Variants",
    "capacityBinding": "Capacity Binding",
    "responseCoverage": "Confidence: {{percent}} of the expected respondents answered",
    "noSteps": "No process steps found",
    "minutesValue": "{{value}}min",
    "stepRecordedBy": "Step recorded by {{name}}",
    "frequency": {
      "weekly": "Weekly",
      "daily": "Daily",
      "monthly": "Monthly",
      "multiple-times-daily": "Multiple Times Daily",
      "once-a-day": "Once a Day",
      "several-times-a-week": "Several times a week",
      "once-per-week": "Once per Week",
      "every-two-weeks": "Every two weeks",
      "every-three-weeks": "Every three weeks",
      "quarterly": "Quarterly",
      "semi-annually": "Semi-Annually",
      "yearly": "Yearly",
      "timesSuffix": " ({{count}}×)"
    },
    "statusNotStarted": "Not started",
    "statusInProgress": "In Progress",
    "statusCompleted": "Completed",
    "statusRecordingComplete": "Recorded",
    "pendingSurveyCount_one": "{{count}} survey open",
    "pendingSurveyCount_other": "{{count}} surveys open",
    "deleteConfirmDescription": "Are you sure you want to delete this process? This action cannot be undone.",
    "duplicateTitle": "Duplicate process",
    "duplicateDescription": "Create a copy of \"{{name}}\" including its recorded steps, assignments, notes and layout.",
    "duplicateNameDefault": "{{name}} (copy)",
    "duplicateSuccess": "Process duplicated successfully",
    "duplicateFailed": "Failed to duplicate process",
    "incompleteStep": "In Progress",
    "type": "Type",
    "task": "Task",
    "decision": "Decision",
    "decisionWithRules": "Decision: {{count}} rules",
    "conditions": "Conditions",
    "stepDescription": "Step description",
    "pendingAssignments": "Pending Assignments",
    "assignedTo": "Assigned To",
    "assignedBy": "Assigned By",
    "sourceStep": "Source Step",
    "status": "Status",
    "assignedDate": "Assigned Date",
    "noPendingAssignments": "No pending assignments",
    "processStart": "Process Start",
    "assignmentStatus": {
      "pending": "Pending",
      "accepted": "Accepted",
      "rejected-reassigned": "Rejected - Reassigned",
      "rejected-unclear": "Rejected - Unclear",
      "pending-unclear": "Pending - Unclear",
      "unclear-reassigned": "Unclear - Reassigned"
    },
    "createProcessesPage": {
      "title": "Create Processes",
      "description": "Add processes to your process world. Either by creating them manually or by uploading them from Excel.",
      "editProcessDescription": "Update the details of this process",
      "addManually": "Add Manually",
      "addManuallyDescription": "Create a process using the form",
      "uploadFromExcel": "Upload from Excel",
      "uploadFromExcelDescription": "Import multiple processes from an Excel file",
      "draftProcesses": "Draft Processes",
      "noDrafts": "No draft processes yet. Add processes to officially create them in BLIKS IO.",
      "createAll": "Create All Processes",
      "cancel": "Cancel",
      "uploadSuccess_one": "Successfully added {{count}} process from Excel",
      "uploadSuccess_other": "Successfully added {{count}} processes from Excel",
      "editProcessTitle": "Edit Process",
      "confirmDelete": "Are you sure you want to delete this process? This action cannot be undone.",
      "successCreated_one": "Successfully created {{count}} process",
      "successCreated_other": "Successfully created {{count}} processes",
      "validationErrors": "Validation Errors",
      "fixErrorsWarning": "Please fix validation errors before creating processes",
      "noDepartmentHead": "The selected department has no department head assigned."
    },
    "capacitySourceSurvey": "Surveyed",
    "capacitySourceManual": "Manual",
    "capacityManualMark": "entered manually",
    "capacityEffective": "effective",
    "capacityIncludesManual": "includes manual values",
    "capacityConfidence": "Confidence: {{percent}}"
  },
  "stepRecording": {
    "confirmReassign": {
      "title": "Confirm Reassignment",
      "description": "Your current progress will be permanently deleted. Are you sure you want to reassign this task?",
      "assigneeLabel": "Reassign to",
      "unclearBody": "This task will be marked as unclear and escalated to the process owner."
    },
    "reassignSuccess": "Task successfully reassigned",
    "reassignError": "Failed to reassign task. Please try again.",
    "reassignMissingInfo": "Cannot reassign: missing recording information",
    "finishError": "Failed to finish recording",
    "stopError": "Failed to stop recording",
    "resumeError": "Failed to return to editing",
    "retryError": "Failed to regenerate summary",
    "review": {
      "title": "Review step",
      "subtitle": "Accept the AI suggestion or edit individual fields with the pencil icon.",
      "subtitleManual": "Enter a title and description for this step.",
      "titlePlaceholder": "Enter a title",
      "descriptionPlaceholder": "Enter a description",
      "titleLabel": "Title",
      "descriptionLabel": "Description",
      "back": "Back to editing",
      "apply": "Apply",
      "editTitle": "Edit title",
      "editDescription": "Edit description",
      "confirmEdit": "Confirm change",
      "cancelEdit": "Discard change",
      "generating": "Generating summary…",
      "generatingBanner": "Bliksy is generating your step summary…",
      "bliksySuggestion": "Bliksy suggestion",
      "failed": "Summary generation failed.",
      "retry": "Try again",
      "regenerate": "Regenerate AI summary",
      "aiError": "AI summary generation failed. Use the regenerate button to try again, or fill in the fields manually."
    }
  },
  "processMap": {
    "title": "Process Landscape",
    "empty": "No processes yet. Create processes to build the landscape map",
    "kpi": {
      "total": "Processes",
      "core": "Core Processes",
      "management": "Management Processes",
      "support": "Support Processes",
      "connections": "Connected Processes",
      "isolated": "Isolated Processes"
    },
    "lanes": {
      "management": "Management",
      "core": "Core Processes",
      "support": "Support",
      "uncategorized": "Uncategorized"
    },
    "uncategorizedHint": "{{count}} processes are not yet categorized. Assign them a category (Core/Management/Support) to structure the landscape.",
    "editorMode": "Edit",
    "resetLayout": "Reset Layout",
    "resetLayoutConfirm": "All manual node positions will be reset to auto-layout. Continue?",
    "saveChanges": "Save",
    "discardChanges": "Discard",
    "tooltip": {
      "connected": "Connected",
      "notConnected": "Not connected",
      "from": "From",
      "to": "To",
      "outputLabel": "Output",
      "startEventLabel": "Start Event"
    },
    "departmentFilter": {
      "placeholder": "Departments",
      "search": "Search departments...",
      "empty": "No departments found",
      "selected": "{{count}} departments",
      "modeHighlight": "Highlight mode: dims non-matching processes",
      "modeFilter": "Filter mode: hides non-matching processes"
    },
    "search": {
      "placeholder": "Search processes...",
      "noResults": "No results"
    },
    "chainFilter": {
      "placeholder": "Process chains",
      "search": "Search chain...",
      "empty": "No chains with processes",
      "selected": "{{count}} chains",
      "modeHighlight": "Highlight mode: dims non-matching processes",
      "modeFilter": "Filter mode: hides non-matching processes"
    },
    "editorHints": {
      "dragNode": "Move process",
      "selectArea": "Select area",
      "pan": "Pan view",
      "multiSelect": "Add to selection",
      "clickPort": "Create connection",
      "leftClick": "Left",
      "rightClick": "Right",
      "shift": "Shift",
      "dragOnNode": "Drag on process",
      "dragOnCanvas": "Drag on canvas"
    },
    "connectDialog": {
      "title": "Create Link",
      "description": "Do you want to create the link?",
      "duplicateTitle": "Connection Already Exists",
      "duplicateDescription": "This connection already exists between the selected ports.",
      "duplicateWarning": "An identical connection already exists. It cannot be created again.",
      "confirm": "link"
    },
    "focusBadge": "Focus: {{name}}",
    "miniMap": {
      "title": "Process Flow",
      "showInLandscape": "Show in Landscape",
      "noConnections": "No connections"
    }
  },
  "connections": {
    "title": "Connections",
    "noConnections": "This process has no connections yet",
    "predecessors": "Predecessors",
    "successors": "Successors",
    "unconnectedPorts": "Unconnected Ports",
    "notConnected": "Not connected",
    "addPredecessor": "Add predecessor",
    "addSuccessor": "Add successor",
    "assignConnection": "Assign",
    "deleteConnection": "Delete connection",
    "deleteConnectionConfirm": "Are you sure you want to delete this connection?",
    "manageConnections": {
      "title": "Manage connections: {{portName}}",
      "description": "Select processes and their ports to create connections.",
      "inputLabel": "Source processes & their outputs",
      "outputLabel": "Target processes & their inputs",
      "save": "Save",
      "saving": "Saving...",
      "saveFailed": "Failed to save connections"
    }
  },
  "portConnectionSelector": {
    "searchPlaceholder": "Search process...",
    "selectedCount": "{{count}} process(es) selected",
    "noInputs": "No inputs available",
    "noOutputs": "No outputs available",
    "allDepartments": "All departments",
    "outputCount": "{{count}} output(s)",
    "inputCount": "{{count}} input(s)"
  },
  "processChains": {
    "title": "Process Chains",
    "createChain": "New Process Chain",
    "categories": {
      "management": "Management",
      "core": "Core",
      "support": "Support"
    },
    "empty": {
      "title": "No process chains found",
      "description": "Create process chains to group your processes into end-to-end workflows."
    },
    "createDialog": {
      "name": "Chain name",
      "namePlaceholder": "e.g. “Order-to-Cash”",
      "description": "Description",
      "descriptionPlaceholder": "Short description of the process chain (optional)",
      "category": "Process chain category"
    },
    "editChain": {
      "title": "Edit process chain",
      "description": "Change the name, description, and category of this process chain."
    },
    "edit": {
      "button": "Edit",
      "title": "Manage processes in the chain",
      "description": "Add, remove, or reorder processes in this chain.",
      "addProcess": "Add process...",
      "noProcesses": "No processes assigned yet",
      "addProcesses": "Add Processes",
      "swimlane": {
        "strategic": "Strategic",
        "core": "Core",
        "support": "Support"
      },
      "remove": "Remove",
      "autoDetect": {
        "button": "Auto-detect",
        "title": "Auto-detect Process Chain",
        "description": "Select a starting process. All linked processes are detected automatically",
        "selectSeed": "Select starting process...",
        "detected": "{{count}} processes detected",
        "addAll": "Add all to chain",
        "noConnections": "This process has no connections to other processes."
      },
      "suggestions": {
        "title": "Suggested processes",
        "hint": "Connected to processes in this chain"
      }
    },
    "detail": {
      "noSubChains": "No sub-chains found.",
      "emptyChainHint": "This chain has no processes or sub-chains yet."
    },
    "deleteChain": {
      "button": "Delete chain",
      "title": "Delete chain",
      "description": "Are you sure you want to delete the chain \"{{name}}\"?",
      "processesWillBeFreed": "{{count}} process(es) will be removed from the chain",
      "childChainsWillBeDeleted": "{{count}} sub-chain(s) will also be deleted",
      "confirm": "Delete chain"
    },
    "drillDown": {
      "root": "Process Chains",
      "childChains": "{{count}} sub-chains",
      "processes": "{{count}} processes",
      "emptyChain": "This chain has no sub-chains or processes yet.",
      "createSubChain": "Create sub-chain",
      "createHere": "Create new chain",
      "editProcesses": "Edit processes"
    }
  },
  "flowKit": {
    "toolbar": {
      "fitView": "Fit view",
      "autoLayout": "Auto-layout",
      "undo": "Undo",
      "redo": "Redo",
      "handTool": "Hand tool (H)",
      "selectTool": "Select tool (V)"
    }
  },
  "stepTemplates": {
    "saveDialog": {
      "title": "Save as step template",
      "name": "Name",
      "description": "Description",
      "selectedCount_one": "{{count}} element selected",
      "selectedCount_other": "{{count}} elements selected",
      "unnamedStep": "Unnamed step",
      "unnamedEvent": "Unnamed event",
      "save": "Save",
      "cancel": "Cancel",
      "saved": "Step template “{{name}}” saved"
    },
    "insertDialog": {
      "title": "Insert step template",
      "empty": "No step templates saved yet.",
      "loadError": "Step templates could not be loaded.",
      "insert": "Insert",
      "cancel": "Cancel",
      "edit": "Edit",
      "delete": "Delete",
      "save": "Save",
      "meta_one": "{{count}} element · {{author}} · {{date}}",
      "meta_other": "{{count}} elements · {{author}} · {{date}}",
      "deleteConfirm": {
        "title": "Delete step template",
        "body": "“{{name}}” is removed from the list for good. Steps already inserted stay unchanged."
      },
      "inserted": "“{{name}}” inserted"
    },
    "error": "Action failed"
  }
}
